import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import BackgroundContainer from '../components/BackgroundContainer';
import BaseHeader from '../components/BaseHeader';
import BaseButton from '../components/BaseButton';
import BaseFormContainer from '../components/BaseFormContainer';
import { Helmet } from 'react-helmet';

const StyledParagraph = styled(Typography)(({ theme }) => ({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.2rem',
  color: '#ffbfe1',
  textAlign: 'center',
  textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
  lineHeight: 1.5,
  marginBottom: theme.spacing(3),
  '@media (max-width: 400px)': {
    fontSize: '1.1rem',
  },
  '@media (max-width: 360px)': {
    fontSize: '1rem',
  },
  '@media (max-width: 320px)': {
    fontSize: '0.95rem',
  },
}));

const ScrollableWrapper = styled(Box)(({ theme }) => ({
  maxHeight: 'calc(100vh - 200px)',
  overflowY: 'auto',
  paddingRight: theme.spacing(1),
  width: '100%',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(255, 191, 229, 0.4)',
    borderRadius: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '8px',
  },
}));

const About = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
    <title>About Deeper – Intimacy & Connection Game</title>
    <meta name="description" content="Deeper was built to guide couples into trust, vulnerability, and deeper connection—through touch, truth, and daring intimacy." />
    <link rel="canonical" href="https://deepergm.com/about" />

    <meta property="og:title" content="About Deeper – Intimacy & Connection Game" />
    <meta property="og:description" content="Learn what makes Deeper a unique couples game for emotional and sexual growth. Trust, vulnerability, and mindful exploration await." />
    <meta property="og:image" content="https://deepergm.com/preview.jpg" />
    <meta property="og:url" content="https://deepergm.com/about" />
    <meta property="og:type" content="article" />
    </Helmet>
    <BackgroundContainer sx={{ overflow: 'hidden' }}>
      <BaseFormContainer sx={{ width: '80%',flex: 1, maxHeight: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <BaseHeader sx={{ fontSize: '3rem', textAlign: 'center', marginBottom: 2 }}>About</BaseHeader>

        <ScrollableWrapper>
          <StyledParagraph>
            This game was created to strengthen the bond between two people.
          </StyledParagraph>

          <StyledParagraph>
            There are many games for couples, but this one is for those who want to dive deeper into sexual intimacy.
          </StyledParagraph>

          <StyledParagraph>
            The journey will allow you to build trust, get to know each other, pleasure each other, open up, explore boundaries safely, 
            and open your mind to sexuality and vulnerability. Play this game
            mindfully, with great care and respect to the body and soul.
          </StyledParagraph>

          <StyledParagraph>
            Play this game with an open heart - touch, talk, and just immerse.
          </StyledParagraph>

          <StyledParagraph>
            Dare to try new things, express yourself differently, and get in-tune with your deep self.
          </StyledParagraph>
        </ScrollableWrapper>

        <BaseButton sx={{ marginTop: 2, alignSelf: 'center' }} onClick={() => navigate('/')}>Back</BaseButton>
      </BaseFormContainer>
    </BackgroundContainer>
    </>
  );
};

export default About;


{/* <Box 
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '15px',
          flexWrap: 'wrap',
          transform: 'rotate(-10deg)'
        }}
      >
        {["Option 1", "Option 2", "Option 3", "Option 4", "Option 5"].map((option, index) => (
          <Card 
            key={index} 
            sx={{
              background: 'linear-gradient(135deg, #ff7a18 0%, #af002d 100%)',
              padding: '20px 40px',
              borderRadius: '15px',
              color: 'white',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'rotate(0deg)',
                boxShadow: '0 10px 20px rgba(0, 0, 0, 0.3)',
              }
            }}
          >
            <CardContent>
              <Typography align="center">{option}</Typography>
            </CardContent>
          </Card>
        ))}
      </Box> */}

//       <Typography variant="h5" sx={{ marginTop: '20px' }}>
//         Matthias
//       </Typography>
//     </Container>
//   );
// };

// export default About;




// import React from "react";
// import styled from "styled-components";

// const About = () => {
//   return (
//     <Container>
//       <Header>
//         <CloseButton>✖</CloseButton>
//         <HeartIcon>❤</HeartIcon>
//       </Header>
//       <CardContainer>
//         {["Option 1", "Option 2", "Option 3", "Option 4", "Option 5"].map((option, index) => (
//           <Card key={index}>{option}</Card>
//         ))}
//       </CardContainer>
//       <Footer>Matthias</Footer>
//     </Container>
//   );
// };

// export default About;

// // Styled components
// const Container = styled.div`
//   background: linear-gradient(135deg, #6b1b9d 0%, #e35f9a 100%);
//   height: 100vh;
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
//   align-items: center;
//   padding: 20px;
//   color: white;
// `;

// const Header = styled.div`
//   width: 100%;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// `;

// const CloseButton = styled.div`
//   font-size: 24px;
//   cursor: pointer;
// `;

// const HeartIcon = styled.div`
//   font-size: 24px;
//   cursor: pointer;
// `;

// const CardContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   gap: 15px;
//   flex-wrap: wrap;
// `;

// const Card = styled.div`
//   background: linear-gradient(135deg, #ff7a18 0%, #af002d 100%);
//   padding: 20px 40px;
//   border-radius: 15px;
//   font-size: 18px;
//   text-align: center;
//   color: white;
//   cursor: pointer;
//   transform: rotate(-10deg);
//   transition: all 0.3s ease;

//   &:hover {
//     transform: rotate(0deg);
//     box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
//   }
// `;

// const Footer = styled.div`
//   font-size: 20px;
//   margin-top: 20px;
// `;

// import React from 'react'

// const About = () => {
//   return (
//     <div>About</div>
//   )
// }

// export default About